import React, {Dispatch, SetStateAction, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {IPresentationMeta} from '../../../../../incase-domain/presentation';
import {useRoomsForPresentation} from '../../queries';
import Select, {Option} from '../../../common/Select';
import {IFetchRoom} from '../../../../../incase-domain/rooms/room.editor';
import {getCssVariable} from '../../../../../utils/style.utils';

interface IRoomSelectionStepProps {
    presentation: IPresentationMeta;
    selectedRoomId: string | undefined;
    setSelectedRoomId: Dispatch<SetStateAction<string | undefined>>;
    setSelectedPresenterLinkCode: Dispatch<SetStateAction<string | undefined>>;
}

function RoomSelectionStep({
    presentation,
    selectedRoomId,
    setSelectedRoomId,
    setSelectedPresenterLinkCode,
}: IRoomSelectionStepProps): JSX.Element {
    const {t} = useTranslation();
    const searchTermRef = useRef<string>('');

    const {data: rooms} = useRoomsForPresentation(presentation._id);

    const options: Option[] =
        rooms?.map((room: IFetchRoom) => ({
            value: room._id,
            label: room.roomName,
        })) || [];

    const handleChange = (selectedOption: Option | null): void => {
        const roomId = selectedOption?.value.toString() || '';
        setSelectedRoomId(roomId);
        const selectedRoom = rooms?.find((room: IFetchRoom) => room._id === roomId);
        setSelectedPresenterLinkCode(selectedRoom?.presenterLinkCode);
    };

    const handleSearchTermChange = (term: string): void => {
        searchTermRef.current = term;
    };

    const placeholder = t('caseWizard.liveEvent.selectRoom');
    const selectRoom = t('caseWizard.liveEvent.selectRoom');

    return (
        <div>
            {!!rooms?.length && (
                <div>
                    <div>{selectRoom}</div>
                    <Select
                        onInputChange={handleSearchTermChange}
                        options={options}
                        placeholder={placeholder}
                        onChange={(e) => handleChange(e)}
                        value={options.find((option) => option.value === selectedRoomId) || undefined}
                        isMenuUsingPortal
                        styles={{
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: getCssVariable('--z-index-modal'),
                            }),
                        }}
                        dontCloseMenuOnScroll
                    />
                </div>
            )}
        </div>
    );
}

export default RoomSelectionStep;
